export function request(metodo, caminho, dados, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open(metodo, caminho, true);
    xhr.onreadystatechange = function () {
        if (xhr.status >= 200 && xhr.status < 400) {
            callback && callback();
        }
    };
    xhr.dados = dados;
    return xhr;
}